import { api } from "./configs/axiosConfigs";

export const CourseWebAPI = {
  getCoursesWeb: async () => {
    const response = await api.get("/courseWebProfile")
      .then((response) => response.data)
      .catch((error) => {
        console.log(error);
        return error.response.data;
      });
    return response;
  },
  getCoursesWebSearch: async (term) => {
    const response = await api
      .get(`/courseWebProfile?term=${term}`)
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        return error.response.data;
      });
    return response;
  },
  createCourseWeb: async (data: any) => {
    const formData = new FormData();
    formData.append("course_id", data.course_id || "");
    formData.append("teacher_id", data.teacher_id || "");
    formData.append("teacher", data.teacher || "");
    formData.append("category_id", data.category_id || "");
    formData.append("category", data.category || "");
    formData.append("description", data.description);
    formData.append("start_date", data.start_date);
    formData.append("end_date", data.end_date);
    formData.append("link_group_whatsapp", data.link_group_whatsapp);
    formData.append("link_form", data.link_form);
    formData.append("modality", data.modality);
    formData.append("slots_available", data.slots_available || 0);
    formData.append("order", data.order);
    if (Array.isArray(data.class_days)) {
      data.class_days.forEach((day, index) => {
        formData.append(`class_days[${index}]`, day);
      });
    }
    if (data.class_schedule) {
      formData.append("class_schedule[start]", data.class_schedule.start);
      formData.append("class_schedule[end]", data.class_schedule.end);
    }

    // formData.append("class_days", JSON.stringify(data.class_days));
    // formData.append("class_schedule", JSON.stringify(data.class_schedule));
    formData.append("status", data.status || "1");
    if (data.image instanceof File) {
      formData.append("image", data.image);
    }
    const response = await api
      .post("/courseWebProfile", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        return error.response.data;
      });
    return response;
  },
  editCourseWeb: async (id: number, data: any) => {
    const formData = new FormData();
    formData.append("course_id", data.course_id || "");
    formData.append("teacher_id", data.teacher_id || "");
    formData.append("teacher", data.teacher || "");
    formData.append("category_id", data.category_id || "");
    formData.append("category", data.category || "");
    formData.append("description", data.description);
    formData.append("start_date", data.start_date);
    formData.append("end_date", data.end_date);
    formData.append("link_group_whatsapp", data.link_group_whatsapp);
    formData.append("link_form", data.link_form || "");
    formData.append("modality", data.modality);
    formData.append("slots_available", data.slots_available || 0);
    formData.append("order", data.order);
    if (Array.isArray(data.class_days)) {
      formData.append("class_days", JSON.stringify(data.class_days));
    }
    if (data.class_schedule) {
      formData.append(
        "class_schedule",
        JSON.stringify(data.class_schedule)
      );
    }
    formData.append("status", data.status || "1");
    if (data.image instanceof File) {
      formData.append("image", data.image);
    }
    const response = await api.post(`/courseWebProfile/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then((response) => response.data).catch((error) => {
      console.error(error);
      return error.response.data;
    });
    return response;
  },
  deleteCourseWeb: async (id: number) => {
    const response = await api
      .delete(`/courseWebProfile/${id}`)
      .then((response) => response.data)
      .catch((error) => {
        return error.response.data;
      });
    return response;
  },
  getTeacher: async () => {
    const response = await api
      .get("/teacher")
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        return error.response.data;
      });
    return response;
  },
  getCategory: async () => {
    const response = await api
      .get("/categoryCourse")
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        return error.response.data;
      });
    return response;
  },
  getCourse: async () => {
    const response = await api
      .get("/course")
      .then((response) => response.data)
      .catch((error) => {
        console.error(error);
        return error.response.data;
      });
    return response;
  },
};